var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "url(#paint0_linear_1812_2714)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 11C28.5304 11 29.0391 11.2107 29.4142 11.5858C29.7893 11.9609 30 12.4696 30 13V25C30 25.5304 29.7893 26.0391 29.4142 26.4142C29.0391 26.7893 28.5304 27 28 27H26V29C26 29.5304 25.7893 30.0391 25.4142 30.4142C25.0391 30.7893 24.5304 31 24 31H14C13.4696 31 12.9609 30.7893 12.5858 30.4142C12.2107 30.0391 12 29.5304 12 29V17C12 16.4696 12.2107 15.9609 12.5858 15.5858C12.9609 15.2107 13.4696 15 14 15H16V13C16 12.4696 16.2107 11.9609 16.5858 11.5858C16.9609 11.2107 17.4696 11 18 11H28ZM24 17H14V29H24V17ZM19 24C19.2652 24 19.5196 24.1054 19.7071 24.2929C19.8946 24.4804 20 24.7348 20 25C20 25.2652 19.8946 25.5196 19.7071 25.7071C19.5196 25.8946 19.2652 26 19 26H17C16.7348 26 16.4804 25.8946 16.2929 25.7071C16.1054 25.5196 16 25.2652 16 25C16 24.7348 16.1054 24.4804 16.2929 24.2929C16.4804 24.1054 16.7348 24 17 24H19ZM28 13H18V15H24C24.5304 15 25.0391 15.2107 25.4142 15.5858C25.7893 15.9609 26 16.4696 26 17V25H28V13ZM21 20C21.2549 20.0003 21.5 20.0979 21.6854 20.2728C21.8707 20.4478 21.9822 20.687 21.9972 20.9414C22.0121 21.1958 21.9293 21.4464 21.7657 21.6418C21.6021 21.8373 21.3701 21.9629 21.117 21.993L21 22H17C16.7451 21.9997 16.5 21.9021 16.3146 21.7272C16.1293 21.5522 16.0178 21.313 16.0028 21.0586C15.9879 20.8042 16.0707 20.5536 16.2343 20.3582C16.3979 20.1627 16.6299 20.0371 16.883 20.007L17 20H21Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1812_2714",
    x1: 21,
    y1: 0,
    x2: 21,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C38CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D67D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.f349ce1346f25c6f04dc73f4ac75e39b.svg";
export { ForwardRef as ReactComponent };